import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PostalComponent } from './components/postal/postal.component';
import { ProductRecommendationComponent } from './components/product-recommendation/product-recommendation.component';
import { AnswerConfirmationComponent } from './components/answer-confirmation/answer-confirmation.component';
import { EmailModalComponent } from './components/shared/email-modal/email-modal.component';
import { HeaderComponent } from './components/shared/header/header.component';
import { ModalComponent } from './components/shared/modal/modal.component';
import { ProgressBarComponent } from './components/shared/progress-bar/progress-bar.component';
import { StepComponent } from './components/step/step.component';
import { ColorGroupsComponent } from './components/visualizer/color-groups/color-groups.component';
import { ColorComponent } from './components/visualizer/color/color.component';
import { LoaderComponent } from './components/visualizer/loader/loader.component';
import { OpacityColorsComponent } from './components/visualizer/opacity-colors/opacity-colors.component';
import { ProjectComponent } from './components/visualizer/project/project.component';
import { ShareProjectComponent } from './components/visualizer/share-project/share-project.component';
import { VisualizerComponent } from './components/visualizer/visualizer/visualizer.component';
import { ZoomComponent } from './components/visualizer/zoom/zoom.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { VariablePipe } from './pipes/variable.pipe';
import { BrandEnvironmentInterceptor } from './services/brand-environment.interceptor';
import { EmailService } from './services/email.service';
import { HistoryService } from './services/history.service';
import { MetaService } from './services/meta.service';
import { ProductService } from './services/product.service';
import { QaService } from './services/qa.service';
import { StartupService } from './services/startup.service';
import { VisualizerService } from './services/visualizer.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SocialMediaService } from './services/social-media.service';
import { WoodConditionImageService } from './services/wood-condition.service';
import { WoodGrainImageService } from './services/wood-grain.service';
import { WoodLookImageService } from './services/wood-look.service';
import { AnswerInfoService } from './services/answer-info.service';
import { ScrollingService } from './services/scrolling.service';
import { BuyOnlineService } from './services/buy-online.service';
import { CultureService } from './services/culture.service';


export function startupServiceFactory(startupService: StartupService): Function {
  return () => startupService.load();
}

@NgModule({
  declarations: [
    AppComponent,
    WelcomeComponent,
    PostalComponent,
    StepComponent,
    HeaderComponent,
    ProgressBarComponent,
    AnswerConfirmationComponent,
    VisualizerComponent,
    VariablePipe,
    ProjectComponent,
    ColorGroupsComponent,
    ZoomComponent,
    ColorComponent,
    ShareProjectComponent,
    ModalComponent,
    OpacityColorsComponent,
    ProductRecommendationComponent,
    EmailModalComponent,
    LoaderComponent ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule
  ],
  providers: [
    StartupService,
    {
      // Provider for APP_INITIALIZER
      provide: APP_INITIALIZER,
      useFactory: startupServiceFactory,
      deps: [StartupService],
      multi: true
    },
    [{
      provide: HTTP_INTERCEPTORS,
      useClass: BrandEnvironmentInterceptor,
      multi: true,
    }],
    QaService,
    VisualizerService,
    ProductService,
    HistoryService,
    MetaService,
    EmailService,
    SocialMediaService,
    WoodConditionImageService,
    WoodGrainImageService,
    WoodLookImageService,
    AnswerInfoService,
    ScrollingService,
    BuyOnlineService
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    AppComponent,
    WelcomeComponent,
    PostalComponent,
    StepComponent,
    AnswerConfirmationComponent,
    VisualizerComponent,
    ProductRecommendationComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts